import { Injectable } from '@angular/core';
import { mdmUrlServices } from 'src/app/mdm/services/mdmServiceUrls';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { encryptionService } from 'src/app/common-service/cedService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';

@Injectable({
  providedIn: 'root'
})
export class MDMServicesService {

  constructor(public http: HttpServiceService, public url: mdmUrlServices, public ced: encryptionService, public serverURL: ServerURLService) { }

  //  getAllCountries
  getAllCountryWithPage(pageId: number, rowId: number, countryname: any, countrycode: any) {
    return this.http.get(this.url.getAllCountrieWithPage + '?page=' + pageId + '&rows=' + rowId + '&countryName=' + countryname + '&countryCode=' + countrycode);
  }

  //save countrymaster added by gokul
  saveCountryMaster(countryobj: any) {
    return this.http.post(this.url.saveCountryMaster, countryobj);
  }

  //  getAllState
  getAllStateWithPage(pageId: number, rowId: number, stateName: any, stateCode: any) {
    return this.http.get(this.url.getAllStateWithPage + '?page=' + pageId + '&rows=' + rowId + '&stateName=' + stateName + '&stateCode=' + stateCode);
  }
  //save statemaster added by gokul
  saveStateMaster(Stateobj: any) {
    return this.http.post(this.url.saveStateMaster, Stateobj);
  }

  //getAllcity
  getAllCityWithPage(citySearchCriteria: any) {
    return this.http.post(this.url.getAllCityWithPage, citySearchCriteria);
  }
  //All city for dropdown
  getAllStates() {
    return this.http.get(this.url.getAllStates);
  }

  getAllCitys() {
    return this.http.get(this.url.getAllCitys);
  }
  //save citymaster added by gokul
  saveCityMaster(cityobj: any) {
    return this.http.post(this.url.saveCityMaster, cityobj);
  }
  cityMstrDetailsById(cityMstrId: number) {
    const cityMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(cityMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.cityMstrDetailsById + '?cityMstrIdEncr=' + cityMstrIdEncr);
  }
  stateMstrDetailsById(stateMstrId: number) {
    const stateMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(stateMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.stateMstrDetailsById + '?stateMstrIdEncr=' + stateMstrIdEncr);
  }
  countryMstrDetailsById(countryMstrId: number) {
    const countryMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(countryMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.countryMstrDetailsById + '?countryMstrIdEncr=' + countryMstrIdEncr);
  }
  getAllCourseWithPage(courseSearchCriteria: any) {
    return this.http.post(this.url.getAllCourseWithPage, courseSearchCriteria);
  }

  getAllUniversityWithPage(universitySearchCriteria: any) {
    return this.http.post(this.url.getAllUniversityWithPage, universitySearchCriteria);
  }

  getAllDepartmentWithPage(departmentSearchCriteria: any) {
    return this.http.post(this.url.getAllDepartmentWithPage, departmentSearchCriteria);
  }

  getAllCollegeDesignationWithPage(collegeDesignationSearchCriteria: any) {
    return this.http.post(this.url.getAllCollegeDesignationWithPage, collegeDesignationSearchCriteria);
  }

  getAllCollegeSpecialisationWithPage(collegespecialisationSearchCriteria: any) {
    return this.http.post(this.url.getAllCollegeSpecialisationWithPage, collegespecialisationSearchCriteria);
  }
  //
  getAllCollegeStaffMasterWithPage(collegeStaffMasterSearchCriteria: any) {
    return this.http.post(this.url.getAllCollegeStaffMasterWithPage, collegeStaffMasterSearchCriteria);
  }

  getAllCollegeStaffTypeMasterWithPage(collegeStaffTypeMasterSearchCriteria: any) {
    return this.http.post(this.url.getAllCollegeStaffTypeMasterWithPage, collegeStaffTypeMasterSearchCriteria);
  }

  getAllDentistMasterWithPage(dentistMasterSearchCriteria: any) {
    return this.http.post(this.url.getAllDentistMasterWithPage, dentistMasterSearchCriteria);
  }
  //
  getAllSdcMasterWithPage(sdcMasterSearchCriteria: any) {
    return this.http.post(this.url.getAllSdcMasterWithPage, sdcMasterSearchCriteria);
  }
  //
  getAllStudentBoardMasterWithPage(studentBoardMasterSearchCriteria: any) {
    return this.http.post(this.url.getAllStudentBoardMasterWithPage, studentBoardMasterSearchCriteria);
  }

  //
  courseMstrDetailsById(courseMstrId: number) {
    const courseMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(courseMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.courseMstrDetailsById + '?courseMstrIdEncr=' + courseMstrIdEncr);
  }

  saveCourseMaster(courseobj: any) {
    return this.http.post(this.url.saveCourseMaster, courseobj);
  }

  //5
  saveUniversityMaster(universityobj: any) {
    return this.http.post(this.url.saveUniversityMaster, universityobj);
  }

  universityMstrDetailsById(universityMstrId: number) {
    const universityMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(universityMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.universityMstrDetailsById + '?universityMstrIdEncr=' + universityMstrIdEncr);
  }


  //6
  saveCollegeDepartmentMaster(collegeDepartmentobj: any) {
    return this.http.post(this.url.saveCollegeDepartmentMaster, collegeDepartmentobj);
  }

  collegeDepartmentMstrDetailsById(collegeDepartmentMstrId: number) {
    const collegeDepartmentMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(collegeDepartmentMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.collegeDepartmentMstrDetailsById + '?collegeDepartmentMstrIdEncr=' + collegeDepartmentMstrIdEncr);
  }

  //7
  saveCollegeDesignationMaster(collegeDesignationobj: any) {
    return this.http.post(this.url.saveCollegeDesignationMaster, collegeDesignationobj);
  }

  collegeDesignationMstrDetailsById(collegeDesignationMstrId: number) {
    const collegeDesignationMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(collegeDesignationMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.collegeDesignationMstrDetailsById + '?collegeDesignationMstrIdEncr=' + collegeDesignationMstrIdEncr);
  }

  //8
  getAllCourseList() {
    return this.http.get(this.url.getAllCourseList);
  }
  saveCollegeSpecialisationMaster(collegeSpecialisationobj: any) {
    return this.http.post(this.url.saveCollegeSpecialisationMaster, collegeSpecialisationobj);
  }

  collegeSpecialisationMstrDetailsById(collegeSpecialisationMstrId: number) {
    const collegeSpecialisationMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(collegeSpecialisationMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.collegeSpecialisationMstrDetailsById + '?collegeSpecialisationMstrIdEncr=' + collegeSpecialisationMstrIdEncr);
  }

  //9
  saveCollegeStaffMaster(collegeStaffMasterobj: any) {
    return this.http.post(this.url.saveCollegeStaffMaster, collegeStaffMasterobj);
  }

  collegeStaffMstrDetailsById(collegeStaffMstrId: number) {
    const collegeStaffMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(collegeStaffMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.collegeStaffMstrDetailsById + '?collegeStaffMstrIdEncr=' + collegeStaffMstrIdEncr);
  }

  //10
  saveCollegeStaffTypeMaster(collegeStaffTypeMasterobj: any) {
    return this.http.post(this.url.saveCollegeStaffTypeMaster, collegeStaffTypeMasterobj);
  }

  collegeStaffTypeMstrDetailsById(collegeStaffTypeMstrId: number) {
    const collegeStaffTypeMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(collegeStaffTypeMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.collegeStaffTypeMstrDetailsById + '?collegeStaffTypeMstrIdEncr=' + collegeStaffTypeMstrIdEncr);
  }

  //11
  saveDentistMaster(dentistMasterobj: any) {
    return this.http.post(this.url.saveDentistMaster, dentistMasterobj);
  }

  dentistMstrDetailsById(dentistMstrId: number) {
    const dentistMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(dentistMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.dentistMstrDetailsById + '?dentistMstrIdEncr=' + dentistMstrIdEncr);
  }

  //12
  saveSdcMaster(sdcMasterobj: any) {
    return this.http.post(this.url.saveSdcMaster, sdcMasterobj);
  }

  sdcMstrDetailsById(sdcMstrId: number) {
    const sdcMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(sdcMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.sdcMstrDetailsById + '?sdcMstrIdEncr=' + sdcMstrIdEncr);
  }

  //13
  saveStudentBoardMaster(studentBoardMasterobj: any) {
    return this.http.post(this.url.saveStudentBoardMaster, studentBoardMasterobj);
  }

  studentBoardMstrDetailsById(studentBoardMstrId: number) {
    const studentBoardMstrIdEncr = encodeURIComponent(this.ced.encryptAesToString(studentBoardMstrId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.studentBoardMstrDetailsById + '?studentBoardMstrIdEncr=' + studentBoardMstrIdEncr);
  }

  getAllStaffTypeList() {
    return this.http.get(this.url.getAllStaffTypeList);
  }

  getAllCollegeList() {
    return this.http.get(this.url.getAllCollegeList);
  }
  getCollegeDropdownList() {
    return this.http.get(this.url.getCollegeDropdownList);
  }

  getCollegeList(role: string) {
  return this.http.get(`${this.url.getCollegeList}?role=${role}`);
}


  getCollegeDropdownListForInsp() {
    return this.http.get(this.url.getCollegeDropdownListForInsp);
  }
  getCollegeDropdownListForInspSch() {
    return this.http.get(this.url.getCollegeDropdownListForInspSch);
  }
  getAllCollegeDepartmentList() {
    return this.http.get(this.url.getAllCollegeDepartmentList);
  }

  getAllCollegeDesignationList() {
    return this.http.get(this.url.getAllCollegeDesignationList);
  }
  getAllCollegeSpecialisation() {
    return this.http.get(this.url.getAllCollegeSpecialisation);
  }

  initiatePaymentDetails(paymentObj: any) {
    return this.http.post(this.url.initiatePayment, paymentObj);
  }
  public personalloadEndate(date) {
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    return date.getFullYear() - 19 + '-' + month + '-' + day
  }

  //Master for note sheet

  getAllDmeMasterWithPage(dmeMasterSearchCriteria: any) {
    return this.http.post(this.url.getAllDmeMasterWithPage, dmeMasterSearchCriteria);
  }

  saveDmeMaster(dmeMasterobj: any) {
    return this.http.post(this.url.saveDmeMaster, dmeMasterobj);
  }

  getDmeMstrDetailsById(stateId: number) {
    const stateIdEncr = encodeURIComponent(this.ced.encryptAesToString(stateId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getDmeMstrDetailsById + '?stateIdEncr=' + stateIdEncr);
  }

  getMasterDataDashboardList(masterDashboardSearchCriteria: any) {
    return this.http.post(this.url.masterDataDashboardList, masterDashboardSearchCriteria);
  }
  getListOfMdmExportPDF(obj: any) {
    return this.http.post(this.url.getListOfMdmExportPDF, obj);
  }
  
  exportMdmExcel(obj: any) {
    return this.http.post(this.url.exportMdmExcel, obj);
  }

  saveUserMaster(userObj: any) {
    return this.http.post(this.url.saveUserMasterDetails, userObj);
  }

  getCollegeMasterDashboardList(masterDashboardSearchCriteria: any) {
    return this.http.post(this.url.collegeMasterDashboardList, masterDashboardSearchCriteria);
  }

  saveCollegeMaster(collegeDto: any) {
    return this.http.post(this.url.saveCollegeMaster, collegeDto);
  }

  updateCollegeAuditLog(collegeDto: any) {
    return this.http.post(this.url.updateCollegeMasterAuditLog, collegeDto);
  }

  geCollegeMstrDetailsById(collegeId: any, userId: any) {
    const collegeIdEncr = encodeURIComponent(this.ced.encryptAesToString(collegeId, this.serverURL.secretKey).toString());
    const userIdEncr = encodeURIComponent(this.ced.encryptAesToString(userId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getCollegeMstrDetailsById + '?collegeIdEncr=' + collegeIdEncr + '&userIdEncr=' + userIdEncr);
  }

  userMasterDetailsById(userId: number) {
    const userIdEncr = encodeURIComponent(this.ced.encryptAesToString(userId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.userMasterDetails + '?userIdEncr=' + userIdEncr);
  }

  getCollegeViewById(entityId: any) {
    const entityIdEncr = encodeURIComponent(this.ced.encryptAesToString(entityId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getCollegeViewByEntityId + '?entityIdEncr=' + entityIdEncr);
  }

  getCollegeViewByCollegeId(collegeId: any) {
    const collegeIdEncr = encodeURIComponent(this.ced.encryptAesToString(collegeId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getCollegeViewByCollegeId + '?collegeIdEncr=' + collegeIdEncr);
  }
}
